module.exports = __webpack_public_path__ + "img/komachi onozuka_sc2.0068bc97.png";